import { AssessmentOutlined, BoltOutlined, Description, ErrorOutlineOutlined, FactCheckOutlined, FlashOnOutlined, FolderSpecialOutlined, Home, PaymentOutlined, PeopleOutline, PeopleOutlineOutlined, PlayArrowOutlined, PlayArrowRounded, PlayCircleOutlineOutlined, Settings, Store, WarningAmberOutlined, WarningOutlined } from "@mui/icons-material";
import { AutomationFileType, Dashboard_Entity, Entity, Entity_Label, ModulePath, StoryStatus } from "./ApplicationVariables";
import { amber, blue, brown, deepOrange, deepPurple, green, grey, orange, pink, purple, yellow } from "@mui/material/colors";
import { ExecutionCustomIcon, PlanningCustomIcon, ReportCustomIcon, TestCaseCustomIcon, UseCaseCustomIcon, UserStoryCustomIcon } from "../components/styled/CustomIcons";
import { SiDependencycheck } from "react-icons/si";
import { RiAdminFill } from "react-icons/ri";
import { alpha } from "@mui/material";
import { font } from "../styles/font";

export const ApplicationPages = [
    {
        label: "Home",
        path: ModulePath?.home,
        icon: <Home />,
        activeIcon: <Home />,
        onClick: () => { }
    },
    {
        label: "Story Map",
        path: ModulePath?.story,
        icon: <Description />,
        activeIcon: <Description />,
        onClick: () => { }
    },
    {
        label: "Marketplace",
        path: ModulePath?.marketplace,
        icon: <Store />,
        activeIcon: <Store />,
        onClick: () => { }
    },
    {
        label: "Execution",
        path: ModulePath?.execution,
        icon: <PlayArrowRounded />,
        activeIcon: <PlayArrowRounded />,
        onClick: () => { }
    },
];

export const STATUS_COLOR = {
    [StoryStatus.pending?.toLowerCase()]: {
        color: brown[700],
        backgroundColor: brown[50],
        textColor: '#000000'
    },
    [StoryStatus.inprogress?.toLowerCase()]: {
        color: blue[700],
        backgroundColor: blue[50],
        textColor: '#000000'
    },
    [StoryStatus.completed?.toLowerCase()]: {
        color: green[700],
        backgroundColor: green[50],
        textColor: '#000000'
    }
}

export const STATE_COLOR = {
    "draft": {
        color: yellow[1000],
        backgroundColor: yellow[200],
        textColor: '#000000'
    },
    "approved": {
        color: blue[1000],
        backgroundColor: blue[200],
        textColor: '#000000'
    },
    "under development": {
        color: orange[1000],
        backgroundColor: orange[200],
        textColor: '#000000'
    },
    "completed": {
        color: green[1000],
        backgroundColor: green[200],
        textColor: '#000000'
    },
    "closed": {
        color: grey[1000],
        backgroundColor: grey[200],
        textColor: '#000000'
    },
}

const IconFontSize = font.size.fs_3

export const DashboardPages = [
    // {
    //     label: Dashboard_Entity.report?.label,
    //     value: Dashboard_Entity.report?.value,
    //     icon: <ReportCustomIcon sx={{ fontSize: IconFontSize }} />,
    // },
    {
        label: Dashboard_Entity.projectDashboard?.label,
        value: Dashboard_Entity.projectDashboard?.value,
        icon: <FolderSpecialOutlined sx={{ fontSize: IconFontSize }} />,
    },
    {
        label: Dashboard_Entity.userStory?.label,
        value: Dashboard_Entity.userStory?.value,
        icon: <UserStoryCustomIcon sx={{ fontSize: IconFontSize }} />,
    },
    {
        label: Dashboard_Entity.useCase?.label,
        value: Dashboard_Entity.useCase?.value,
        icon: <UseCaseCustomIcon sx={{ fontSize: IconFontSize }} />,
    },
    {
        label: Dashboard_Entity.testCase?.label,
        value: Dashboard_Entity.testCase?.value,
        icon: <TestCaseCustomIcon sx={{ fontSize: IconFontSize }} />,
    },
    // {
    //     label: Dashboard_Entity.teams?.label,
    //     value: Dashboard_Entity.teams?.value,
    //     icon: <PeopleOutline sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label : Dashboard_Entity.traceability?.label,
    //     value : Dashboard_Entity.traceability?.value,
    //     icon : <FolderSpecialOutlined />,
    // },
    // {
    //     label: Dashboard_Entity.cost?.label,
    //     value: Dashboard_Entity.cost?.value,
    //     icon: <PaymentOutlined sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label: Dashboard_Entity.userPersona?.label,
    //     value: Dashboard_Entity.userPersona?.value,
    //     icon: <PeopleOutlineOutlined />,
    // },
    // {
    //     label: Dashboard_Entity.qualityAssurance?.label,
    //     value: Dashboard_Entity.qualityAssurance?.value,
    //     icon: <FactCheckOutlined />,
    // },
    {
        label: Dashboard_Entity.planning?.label,
        value: Dashboard_Entity.planning?.value,
        icon: <PlanningCustomIcon sx={{ fontSize: IconFontSize }} />,
    },
    {
        label: Dashboard_Entity.execution?.label,
        value: Dashboard_Entity.execution?.value,
        icon: <ExecutionCustomIcon sx={{ fontSize: IconFontSize }} />,
    },
    // {
    //     label: Dashboard_Entity.risks?.label,
    //     value: Dashboard_Entity.risks?.value,
    //     icon: <WarningAmberOutlined sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label: Dashboard_Entity.action?.label,
    //     value: Dashboard_Entity.action?.value,
    //     icon: <BoltOutlined sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label: Dashboard_Entity.issues?.label,
    //     value: Dashboard_Entity.issues?.value,
    //     icon: <ErrorOutlineOutlined sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label: Dashboard_Entity.dependencies?.label,
    //     value: Dashboard_Entity.dependencies?.value,
    //     icon: <SiDependencycheck sx={{ fontSize: IconFontSize }} />,
    // },
    // {
    //     label: Dashboard_Entity.decision?.label,
    //     value: Dashboard_Entity.decision?.value,
    //     icon: <RiAdminFill sx={{ fontSize: IconFontSize }} />,
    // }



];


export const CARD_COLOR = {
    [Entity.project]: amber[900],
    [Entity.programme]: blue[900],
    [Entity.organisation]: deepOrange[900],
    [Entity.userStory]: purple[900],
    [Entity.useCase]: yellow[900],
    [Entity.testCase]: brown[900],
    [Entity.task]: pink[900],
    [Entity.regression]: green[900],
    [Entity.report]: green[900],
    [Entity.release]: deepPurple[900],

}

export class ACTIVE_PROJECT_TABS {
    static dashboard = 0;
    static userStory = 1;
    static useCase = 2;
    static testCase = 3;
}

export class Filters {
    static status = "status";
    static createdAt = "createdAt";
    static createdBy = "createdBy";
    static assignedTo = "assignedTo";
    static priority = "priority";
    static moduleName = "moduleName";
    static projectName = "projectName";
}

// --- Field Configuration ---
export class Field_Configuration {
    static fieldType = "Field Type";
    static fieldLength = "Field Length";
    static fieldValidation = "Field Validation";
    static elementId = "Element Id";
}

// --- Edit Section Keys ---
export class EditSection {
    static customId = "customId";
    static title = "title";
    static description = "description";
    static steps = "steps";
    static linked = "linked";
    static linkedTestCase = "linkedTestCase";

    static acceptanceCriteria = "acceptanceCriteria";
    static attachments = "attachments";
    static status = "status";
    static assignedTo = "assignedTo";
    static priority = "priority";
    static category = "category";
    static moscow = "moscow";
    static storyType = "storyType";
    static userFields = "userFields";
    static userPoints = "userPoints";
    static plannedInRelease = "plannedInRelease";
    static plannedInSprint = "plannedInSprint";
    static confidenciality = "confidenciality";
    static underSOXCategory = "underSOXCategory";
    static environment = "environment";
    static verificationOwner = "verificationOwner";
    static verificationMethod = "verificationMethod";
    static dependency = "dependency";
    static businessValue = "businessValue";
    static userPersona = "userPersona";
    static testingCriteria = "testingCriteria";
    static businessUnit = "businessUnit";
    static vendor = "vendor";
    static externalPoints = "externalPoints";
    static subProducts = "subProducts";

    static testType = "testType";
    static candidateForRegression = "candidateForRegression";
    static executedBy = "executedBy";
    static executionDate = "executionDate";
    static executionMode = "executionMode";
    static executionEnvironment = "executionEnvironment";
    static executionHistory = "executionHistory";

    static dueDate = "dueDate";
    static members = "members";
    static checklist = "checklist";
    static label = "label";
    static comments = "comments";
    static activity = "activity";

    static expectedResult = "expectedResult";
    static actualResult = "actualResult";
    static preCondition = "preCondition";
    static postCondition = "postCondition";
}

// --- Accordion Names ---
export class AccordionName {
    static details = "details";
    static attachments = "attachments";
    static otherFields = "otherFields";
    static estimationStoryPoints = "estimation_StoryPoints";
    static linkTo = "linkTo";
    static tagTo = "tagTo";
    static linkedUseCase = "linkedUseCase";
    static linkedTestCase = "linkedTestCase";
    static linkedUserStory = "linkedUserStory";
    static execution = "execution";
}

// --- Local Templates/Content Types ---
export class Local_TemplateType {
    static manual = "Manual";
    static automation = "Automation";
}

export class Local_StepsContentType {
    // Assuming AutomationFileType is available in the environment where this class is used
    static script = AutomationFileType.script; 
    static element = AutomationFileType.element;
    static application = AutomationFileType.application;
    static testData = AutomationFileType.testData;
}